/**
 * @desc 更新是否包税字段
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.TransportTaxIncludeRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/changeTaxInclude`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
